import { NgZone } from '@angular/core';

export function delayRunInZone<T = any>(zone: NgZone, fn: () => T, delayMs = 0, inZone = true) {
	return zone && fn && zone.runOutsideAngular(() => setTimeout(() => (inZone ? zone.run(() => fn()) : fn()), delayMs));
}
